module.exports = __webpack_public_path__ + "img/blog.064e10e8.png";